import { useUpdateInventoryHardwareMutation } from "../../api/api-hooks";
import { AddForm } from "./inventoryTypes";

const useInventoryHardwareItemUpdater = () => {
  const [editAnalyzer] = useUpdateInventoryHardwareMutation();
  return (item: AddForm, id: number) => {
    if (!item.hardwareType)
      return { error: { data: { message: "Missing required fields" } } };
    return editAnalyzer({
      id,
      updateInventoryHardwareDto: {
        ...item,
        id,
        hardwareTypeId: Number(item.hardwareType.id),
        dateReceived: item.dateReceived ? item.dateReceived : null,
      },
    });
  };
};

export default useInventoryHardwareItemUpdater;
